import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from './-zod-schemas';
export const Route = createFileRoute('/_staff/person/$id/_profile/apps/')({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({
    search
  }) => ({
    search
  })
});